import React from "react";
import { Route, Routes } from "react-router-dom";
import PublicLayout from "./public";
import PrivateLayout from "./private";

function Views() {
  return (
    <>
      <PublicLayout />
      <PrivateLayout/>
    </>
  );
}

export default Views;
